// Player display name: localStorage, not sessionStorage — a name is a durable identity the player wants
// remembered across visits, unlike the per-tab reconnect token (net/tokenStore.ts), which deliberately
// lives in sessionStorage so two tabs never fight over one bearer credential. Do not mix the two stores.
import { t } from './i18n/index.js';

const KEY = 'ashen-plate-name';
const MAX_LEN = 24;
/** Trim, collapse inner whitespace, cap length; '' when nothing usable remains (a nameless player — shown
    through playerLabel(), in the viewer's language; the server does the same, protocol 21).
    Pure and DOM-free so it is unit-tested directly; the server will apply the same policy once the name
    travels on the wire (see this subtask's report), so this is also the spec for that. */
export function normalizeName(raw: string): string {
  const cleaned = raw.trim().replace(/\s+/g, ' ').slice(0, MAX_LEN);
  return cleaned;
}

const HTML_ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
/** A player name is the first free-text string this app ever puts into innerHTML (every other label is
    from a fixed enum or server-controlled id) — escape it wherever it's displayed, including a stored
    one still open once the wire field lands and other players' names start appearing the same way. */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => HTML_ESCAPES[c]!);
}

/** A player's display name; a nameless one ('' or missing) reads «Игрок» / "Player". */
export function playerLabel(name: string | null | undefined): string {
  return name || t('player.nameless');
}

export function readName(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function writeName(name: string) {
  try { localStorage.setItem(KEY, name); } catch { /* private mode, ignore */ }
}
